import "./App.css";
import Toolbar from "./components/Toolbar/Toolbar";
import SideDrawer from "./components/SideDrawer/SideDrawer";
import Backdrop from "./components/Backdrop/Backdrop";
import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import SideBar from "./components/SideBar/SideBar";
import ResultItem from "./components/ResultItem/ResultItem";
import Tree from "./components/Tree/Tree";
import SearchBar from "./components/SearchBar/SearchBar";
import SummaryBar from "./components/SummaryBar/SummaryBar";
import ResultBar from "./components/ResultBar/ResultBar";
import Accueil from "./components/Accueil/Accueil";
import Process from "./components/Settings/Process/Process";
import Authentification from "./components/Connexion/Authentification/Authentification";
import CreateAnAccount from "./components/Connexion/CreateAnAccount/CreateAnAccount";
import ResetPassword from "./components/Connexion/ResetPassword/ResetPassword";
import ChangePassword from "./components/Connexion/ChangePassword/ChangePassword";
import User from "./components/Connexion/User/User";
import Kanban from "./components/Dashboard/Kanban/Kanban";
import Request from "./components/Dashboard/Request/List";
import Gantt from "./components/Dashboard/Gantt/Gantt";
import Demo from "./components/Connexion/Demo/Demo";
import Decision from "./components/Settings/Decision/Decision";
import DropDownList from "./components/DropDownList/DropDownList";
import AccordionList from "./components/AccordionList/AccordionList";
import Workflow from "./components/Settings/Workflow/Workflow";
import FormSettings from "./components/Settings/FormSettings/FormSettings";
import Organigram from "./components/Settings/Organigram/Organigram";
import TreeItem from "./components/TreeItem/TreeItem";
import ProfilCar from "./components/ProfilCar/ProfilCar";
import RichTextEditor from "./components/Commands/RichTextEditor/RichTextEditor";
import Information from "./components/Settings/Information/Information";
import SettingsStep from "./components/Settings/Information/SettingsStep";
import ProtectedRoute from "./ProtectedRoute";
import Cookies from "js-cookie"
import { store } from "./store.js";
import TaskDetails from "./components/Dashboard/Kanban/TaskDetails";

import List from "./components/Dashboard/Request/List";

export default function App () {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [state, setState] = useState({
    formData: {
      lists: {
        currentMaxId: 0,
      },
      metaData: [],
    }, 
    tools: [
      {
        id: 1,
        type: "Actions",
        items: [
          {
            id: 2,
            name: "Button",
            template: {
              id: 0,
              order: 0,
              type: "Button",
              properties: { 
                name: {value: "Button",  control:"TextBox"},
                text: {value: "Button",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"white"},
                
                visibility: {value:"visible"},
                borderLeft: {value:"none"},
                borderTop: {value:"none"},
                borderTopLeftRadius: {value:"2px"},
                borderTopRightRadius: {value:"2px"},
                borderRight: {value:"none"},
                borderBottom: {value:"none"},
                borderBottomLeftRadius: {value:"2px"},
                borderBottomRightRadius: {value:"2px"},
                                
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                height: {value:"100px", hide:true},
                outline: {value:"none", hide:true},
                backgroundColor: {value:"#008dff"}, 
               
              },
            },
           
          },
          {
            id: 3,
            name: "SideBar",
            template: {
              id: 0,
              order: 0,
              type: "SideBar",
              properties: { 
                name: {value: "SideBar" ,  control:"TextBox"}, 
                text: {value: "SideBar" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"none"},
                left: {value:0, hide:true},
                top: {value:0, hide:true},
                width: {value:"100", hide:true},
                height: {value:"100", hide:true},
                outline: {value:"none", hide:true},
              },
            },
          },
          {
            id: 4,
            name: "ToolBar",
            template: {
              id: 0,
              order: 0,
              type: "ToolBar",
              properties: { 
                name: {value: "ToolBar" ,  control:"TextBox"}, 
                text: {value: "ToolBar",  control:"TextBox"},
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                resize: {value:"Vertical", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"none"},
                background:{value:"white"},
               
                
                left: {value:0, hide:true},
                top: {value:0, hide:true},
                width: {value:"100%", hide:true},
                height: {value:"50px", hide:true},
                outline: {value:"none", hide:true},
              },
            },
          },
          {
            id: 28,
            name: "MenuItem",
            template: {
              id: 0,
              order: 0,
              type: "MenuItem",
              properties: {
                name: {value: "MenuItem",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                menuItem: {value: true ,  control:"CheckBox", hide:true},
                width: {value: "200px" ,  control:"TextBox"},
                type: {value: "String" ,  control:"ListBox" , hide:true},
                toolTip: {value: false ,  control:"CheckBox", hide:true},
                toolTipText: {value: "" ,  control:"TextBox", hide:true},
                actualize: {value: 0,  control:"TextBox", hide:true},
                nullable: {value: true ,  control:"CheckBox", hide:true},
                text: {value: "ListBox",  control:"TextBox", hide:true},
                index: {value: false ,  control:"CheckBox", hide:true},
                data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}}, options:["Tree"], control:"TextBox"}
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px" , hide:true},
                height: {value:"25px", hide:true},
                display: {value:"flex", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
        ],
      },
      {
        id: 5,
        type: "Containers",
        items: [
          {
            id: 6,
            name: "GroupBox",
            template: {
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "GroupBox",  control:"TextBox"}, 
                text: {value: "GroupBox",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}
               },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                visibility: {value:"visible"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                height: {value:"100px", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"1px solid #cccccc"},
                background: {value:"white"},
              },
            },
          },
          {
            id: 26,
            name: "Panel",
            template: {
              id: 0,
              order: 0,
              type: "Panel",
              properties: { 
                name: {value: "Panel",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                text: {value: "Panel",  control:"TextBox"} },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                visibility: {value:"visible"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                height: {value:"100px", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"1px solid #cccccc"},
                background: {value:"white"},
              },
            },
          },
          {
            id: 21,
            name: "TabPanel",
            template: {
            id: 0,
            order: 0,
            type: "TabPanel",
            properties: { 
              name: {value: "TabPanel",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              text: {value: "TabPanel",  control:"TextBox"} },
            policy: { read: true, edit: true, delete: true },
            panelTemplate:{
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "Panel",  control:"TextBox"}
              , text: {value: "Panel",  control:"TextBox"} 
            },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0},
                top: {value:0},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
              },         
            },
            metaData: [
              {
                id: 0,
                order: 0,
                type: "GroupBox",
                properties: { 
                  name: {value: "Panel",  control:"TextBox"}, 
                  text: {value: "Panel",  control:"TextBox"} },
                policy: { read: true, edit: true, delete: true },
                metaData: [],
                styles: {
                  fontSize: {value:"14px"},
                  color: {value:"rgba(73, 80, 87)"},
                  left: {value:0},
                  top: {value:0},
                     
                  border: {value:"1px solid #cccccc"},
                  backgroundColor: {value:"white"},
                },
                 
                }
              ],
            styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#008dff"},
                visibility: {value:"visible"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"400px", hide:true},
                height: {value:"200px", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"none"},
                background: {value:"rgba(248, 249, 250)"},
              },
            },
          },
          {
            id: 24,
            name: "ListView",
            template: {
            id: 0,
            order: 0,
            type: "ListView",
            properties: { 
              name: {value: "ListView",  control:"TextBox"}, 
              text: {value: "ListView",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              accordion: {value: true,  control:"CheckBox"},
            },
            panelTemplate:{
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "ListView",  control:"TextBox"}, 
                text: {value: "ListView",  control:"TextBox"},
                collapse: {value: false,  control:"CheckBox"}, 
              },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0},
                top: {value:0},
                height: {value:"20px"},
                position: {value:"absolute"},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
                resize: {value:"Vertical"},
                overflow: {value:"auto"},
              },
            },
            policy: { read: true, edit: true, delete: true },
            metaData: [
              {
                id: 0,
                order: 0,
                type: "GroupBox",
                properties: { 
                  name: {value: "ListView",  control:"TextBox"}, 
                  text: {value: "ListView",  control:"TextBox"},
                  collapse: {value: false,  control:"CheckBox"}, 
                },
                policy: { read: true, edit: true, delete: true },
                metaData: [],
                styles: {
                  fontSize: {value:"14px"},
                  color: {value:"rgba(73, 80, 87)"},
                  left: {value:0},
                  top: {value:0},
                  height: {value:"20px"},
                  position: {value:"absolute"},
                  border: {value:"1px solid #cccccc"},
                  backgroundColor: {value:"white"},
                  resize: {value:"Vertical"},
                  overflow: {value:"auto"},
                },
              },
            ],
            styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#008dff"},
                visibility: {value:"visible"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"400px", hide:true},
                height: {value:"200px", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"none"},
                background: {value:"rgba(248, 249, 250)"},
              },
            },
          },
          {
            id: 25,
            name: "SplitListView",
            template: {
            id: 0,
            order: 0,
            type: "SplitListView",
            properties: { 
              name: {value: "SplitListView",  control:"TextBox"}, 
              text: {value: "SplitListView",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
            },
            panelTemplate:{
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "SplitListView",  control:"TextBox"}, 
                text: {value: "SplitListView",  control:"TextBox"} },
                policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0, hide:true},
                top: {value:0, hide:true},
                height: {value:"40px", hide:true},
                width: {value:"40px", hide:true},
                position: {value:"absolute", hide:true},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
            policy: { read: true, edit: true, delete: true },
            metaData: [
              {
                id: 0,
                order: 0,
                type: "GroupBox",
                properties: { 
                  name: {value: "SplitListView",  control:"TextBox"}, 
                  text: {value: "SplitListView",  control:"TextBox"} },
                policy: { read: true, edit: true, delete: true },
                metaData: [],
                styles: {
                  fontSize: {value:"14px"},
                  color: {value:"rgba(73, 80, 87)"},
                  left: {value:0, hide:true},
                  top: {value:0, hide:true},
                  height: {value:"40px", hide:true},
                  width: {value:"40px", hide:true},
                  position: {value:"absolute", hide:true},
                  border: {value:"1px solid #cccccc"},
                  backgroundColor: {value:"white"},
                  resize: {value:"both", hide:true},
                  overflow: {value:"auto", hide:true},
                },
              },
            ],
            styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#008dff"},
                visibility: {value:"visible"},
                left: {value:0, hide:true},
                top: {value:0, hide:true},
                width: {value:"400px", hide:true},
                height: {value:"200px", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"none", hide:true},
                background: {value:"rgba(248, 249, 250)"},
              },
            },
          }
        ],
      },
      {
        id: 7,
        type: "Controls",
        items: [
          {
            id: 8,
            name: "Attachment",
            template: {
              id: 0,
              order: 0,
              type: "Attachment",
              properties: {
                name: {value: "Attachment",  control:"TextBox"},
                field: {value: "Attachment" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                toolTip: {value: true ,  control:"CheckBox"},
                toolTipText: {value: "" ,  control:"TextBox"},
                type: {value: "String" ,  control:"ListBox"},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: "",  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"},
                extension: {value: ".txt",  control:"ListBox"},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                display: {value:"flex", hide:true},
                alignItems: {value:"center", hide:true},
                width: {value:"100px", hide:true},
                height: {value:"25px", hide:true},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 22,
            name: "AutoComplete",
            template: {
              id: 0,
              order: 0,
              type: "AutoComplete",
              properties: {
                name: {value: "AutoComplete",  control:"TextBox"},
                field: {value: "AutoComplete" ,  control:"TextBox"},
                type: {value: "String" ,  control:"ListBox"},
                actions: {value: "",  control:"TextBox"},
                toolTip: {value: true ,  control:"CheckBox"},
                toolTipText: {value: "" ,  control:"TextBox"},
                actualize: {value: 0,  control:"TextBox", hide:true},
                size: {value: 0,  control:"TextBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: {id: null,  item:""},  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"},
                placeholder: {value: "AutoComplete",  control:"TextBox"},
                data: {value:{ list:{}, mapping:{}}, options:["List", "Mapping"],  control:"TextBox"},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"150px", hide:true},
                height: {value:"25px", hide:true},
                display: {value:"flex", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"1px solid #cccccc"},
                position: {value:"absolute"},
              },
            },
          },
          {
            id: 9,
            name: "CheckBox",
            template: {
              id: 0,
              order: 0,
              type: "CheckBoxLabel",
              properties: { 
                name: {value: "CheckBox",  control:"TextBox"},
                field: {value: "CheckBox" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                type: {value: "Boolean" ,  control:"ListBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: "CheckBox",  control:"TextBox", hide:true}, 
                index: {value: false ,  control:"CheckBox"},
                operators: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                    {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                display: {value:"flex", hide:true},
                alignItems: {value:"center", hide:true},
                width: {value:"100px", hide:true},
                height: {value:"25px", hide:true},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 12,
            name: "DateTime",
            template: {
              id: 0,
              order: 0,
              type: "DateTime",
              properties: {
                name: {value: "DateTime" ,  control:"TextBox"},
                field: {value: "DateTime" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                type: {value: "DateTime" ,  control:"ListBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: "",  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"},
                date: {value: true,  control:"CheckBox"},
                dateFormat: {value: "dd/mm/yyyy",
                values:[
                  {id: "1",  item:"dd/mm/yyyy",  value:"dd/mm/yyyy"},
                  {id: "2",  item:"mm/dd/yyyy",  value:"mm/dd/yyyy"},
                  {id: "3",  item:"yyyy/mm/dd",  value:"yyyy/mm/dd"},
                  {id: "4",  item:"yyyy/dd/mm",  value:"yyyy/dd/mm"}
                ]
                ,  type:"Date",  control:"ListBox"},
                time: {value: false,  control:"CheckBox"},
                timeFormat: {value: "hh:mm:ss",
                values:[
                  {id: "1",  item:"hh:mm:ss",  value:"hh:mm:ss"},
                  {id: "2",  item:"hh:mm",  value:"hh:mm"},
                  {id: "3",  item:"hh",  value:"hh"},
                  {id: "4",  item:"mm",  value:"mm"},
                  {id: "5",  item:"ss",  value:"ss"}
                ]
                ,  type:"Time",  control:"ListBox"},
                operators: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                    {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                    {id: "3",  item:"greater",  value:{id:"3",  type:"greater"}},
                    {id: "4",  item:"greater & equal",  value:{id:"4",  type:"greater & equal"}},
                    {id: "5",  item:"lower",  value:{id:"5",  type:"lower"}},
                    {id: "6",  item:"lower & equal",  value:{id:"6",  type:"lower & equal"}}
                  ]
                },
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                height: {value:"25px"},
                width: {value:"170px", hide:true},
                display: {value:"flex", hide:true},
                alignItems: {value:"center", hide:true},
               
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 13,
            name: "DataGrid",
            template: {
              id: 0,
              order: 0,
              currentMaxId: 0,
              type: "DataGrid",
              selectedValues: [],
              properties: {
                name: {value: "DataGrid",  control:"TextBox"},
                text: {value: "DataGrid",  control:"TextBox"},
                sliceStart: {value: 1,  control:"TextBox"},
                sliceSize: {value: 10,  control:"TextBox"},
                size: {value: 0,  control:"TextBox", hide:true},
                actualize: {value: 0,  control:"TextBox", hide:true},
                search: {value: true,  control:"CheckBox"},
                header: {value: true,  control:"CheckBox"},
                filter: {value: true,  control:"CheckBox"},
                actions: {value: "",  control:"TextBox"},
                data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}, mapping:{}, input:{}}, options:["Mapping"], control:"TextBox"}
              },
              metaData: [
                
                {
                    id: 0,
                    order: 0,
                    currentMaxId: 0,
                    type: "SearchGrid",
                    properties: {
                      name: {value: "SearchGrid",  control:"TextBox"},
                      text: {value: "SearchGrid",  control:"TextBox"},
                    },
                    metaData: [],                    
                    policy: { read: true, edit: true, delete: true },
                    styles: {
                      fontSize: {value:"14px"},
                      fontFamily: {value:"Arial"},
                      color: {value:"#212121"},
                      backgroundColor: {value:"#e7e7e7"},
                      height: {value:"30px", hide:true},
                      width: {value:"100%", hide:true},
                      display: {value:"flex", hide:true},
                      position: {value:"relative", hide:true},
                      boxSizing: {value:"border-box", hide:true},
                      overflow: {value:"hidden", hide:true},
                      border: {value:"1px solid #cccccc"},
                    },
                 },
                 {
                  id: 0,
                  order: 0,
                  currentMaxId: 0,
                  type: "Header",
                  properties: {
                    name: {value: "Header",  control:"TextBox"},
                    text: {value: "Header",  control:"TextBox"},
                  },
                  metaData: [],                    
                  policy: { read: true, edit: true, delete: true },
                  styles: {
                    fontSize: {value:"14px"},
                    fontFamily: {value:"Arial"},
                    color: {value:"#cccccc"},
                    backgroundColor: {value:"#e7e7e7"},
                    height: {value:"30px", hide:true},
                    width: {value:"100%", hide:true},
                    display: {value:"flex", hide:true},
                    position: {value:"relative", hide:true},
                    boxSizing: {value:"border-box", hide:true},
                    overflow: {value:"hidden", hide:true},
                    border: {value:"1px solid #cccccc"}
                  },
                },
                {
                 id: 0,
                 order: 0,
                 currentMaxId: 0,
                 type: "Filter",
                 
                 properties: {
                   name: {value: "Filter",  control:"TextBox"},
                   text: {value: "Filter",  control:"TextBox"},
                 },
                 metaData: [],                    
                 policy: { read: true, edit: true, delete: true },
                 styles: {
                   fontSize:{value: "14px"},
                   fontFamily: {value:"Arial"},
                   color: {value:"#cccccc"},
                   backgroundColor: {value:"white"},
                   height: {value:"30px", hide:true},
                   width: {value:"100%", hide:true},
                   display: {value:"flex", hide:true},
                   position: {value:"relative", hide:true},
                   boxSizing: {value:"border-box", hide:true},
                   overflow: {value:"hidden", hide:true},
                   border: {value:"1px solid #cccccc"}
                 },
                },
                {
                 id: 0,
                 order: 0,
                 currentMaxId: 0,
                 type: "Rows",
                 
                 properties: {
                   name: {value: "Rows",  control:"TextBox"},
                   text: {value: "Rows",  control:"TextBox"},
                 },
                 metaData: [],                    
                 policy: { read: true, edit: true, delete: true },
                 styles: {
                   fontSize: {value:"14px"},
                   fontFamily: {value:"Arial"},
                   color: {value:"#cccccc"},
                   backgroundColor:{value: "white"},
                   height: {value:"30px", hide:true},
                   width: {value:"100%", hide:true},
                   display: {value:"flex", hide:true},
                   position: {value:"relative", hide:true},
                   boxSizing: {value:"border-box", hide:true},
                   overflow: {value:"hidden", hide:true},
                   border: {value:"1px solid #cccccc"}
                 },
                }
              ],
              
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#cccccc"},
               
                width: {value:"500px", hide:true},
                height: {value:"300px", hide:true},
                resize: {value:"both", hide:true},
                
                position: {value:"absolute", hide:true},
                boxSizing: {value:"border-box", hide:true},
                zIndex: {value:1, hide:true},
                backgroundColor: {value:"white"},
                border: {value:"1px solid #cccccc"},
                overflow: {value:"auto", hide:true},
               
                left: {value:10, hide:true},
                top: {value:50, hide:true},
              },
              excludesDropTypes: ["Label","DataGrid","Line","Radio","GroupBox","Button","RichTextBox","TreeBox", "TextEditor"],
              
            },
          },
          {
            id: 27,
            name: "TextEditor",
            template: {
              id: 0,
              order: 0,
              type: "TextEditor",
              properties: { 
                name: {value: "TextEditor",  control:"TextBox"},
                field: {value: "TextEditor" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                type: {value: "String" ,  control:"ListBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                showToolBar: {value: true ,  control:"CheckBox"},
                size: {value: 500 ,  control:"TextBox"},
                text: {value: "",  control:"TextBox"} ,
                index: {value: false ,  control:"CheckBox"},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                border:{value:"1px solid #cccccc"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"500px", hide:true},
                height: {value:"200px", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 14,
            name: "HyperText",
            template: {
              id: 0,
              order: 0,
              type: "HyperText",
              properties: {
                name: {value: "HyperText",  control:"TextBox"},
                field: {value: "HyperText" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                type: {value: "String" ,  control:"ListBox", hide:true},
                toolTip: {value: true ,  control:"CheckBox"},
                toolTipText: {value: "" ,  control:"TextBox"},
                nullable: {value: true ,  control:"CheckBox"},              
                text: {value: "",  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                width: {value:"110px", hide:true},
                display: {value:"flex", hide:true},
                alignItems: {value:"center", hide:true},
                height: {value:"25px", hide:true},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 15,
            name: "Label",
            template: {
              id: 0,
              order: 0,
              type: "Label",
              properties: { 
                name: {value: "Label",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                text: {value: "Label",  control:"TextBox"} ,
                readOnly: {value: true ,  control:"CheckBox", hide:true},
                eventInfo: {value: false ,  control:"CheckBox"}, 
                type: {
                  value: "",  
                  control:"ListBox",
                  values:[
                    {id: "0",  item:"",  value:""},
                    {id: "1",  item:"H1",  value:"H1"},
                    {id: "2",  item:"H2",  value:"H2"},
                    {id: "3",  item:"H3",  value:"H3"},
                    {id: "4",  item:"H4",  value:"H4"},
                    {id: "5",  item:"H5",  value:"H5"},
                    {id: "6",  item:"H6",  value:"H6"},
                  ]
                }
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                visibility: {value:"visible"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                paddingTop: {value:"3px", hide:true},
                height: {value:"25px", hide:true},
                border: {value:"none"},
                display: {value:"flex", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 16,
            name: "ListBox",
            template: {
              id: 0,
              order: 0,
              type: "ListBox",
              properties: {
                name: {value: "ListBox",  control:"TextBox"},
                field: {value: "ListBox" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                menuItem: {value: false ,  control:"CheckBox", hide:true},
                width: {value: "200px" ,  control:"TextBox"},
                type: {value: "String" ,  control:"ListBox" , hide:true},
                toolTip: {value: true ,  control:"CheckBox"},
                toolTipText: {value: "" ,  control:"TextBox"},
                actualize: {value: 0,  control:"TextBox", hide:true},
                size: {value: 0,  control:"TextBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: {id: null,  item:""},  control:"TextBox", hide:true},
                index: {value: false ,  control:"CheckBox"},
                data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}}, options:["List", "Mapping"], control:"TextBox"},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                height: {value:"25px", hide:true},
                display: {value:"flex", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                position: {value:"absolute"},
              },
            },
          },
          {
            id: 17,
            name: "Line",
            template: {
              id: 0,
              order: 0,
              type: "Line",
              properties: { 
                name: {value: "Line",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                text: {value: "Line",  control:"TextBox"} },
              policy: { read: true, edit: true, delete: true },
              styles: {
                width: {value:"100px", hide:true},
                height: {value:"2px", hide:true},
                color: {value:"#212121"},
                resize: {value:"horizontal"},
                overflow: {value:"auto"},
                left: {value:10},
                top: {value:50},
              },
            },
          },
          {
            id: 18,
            name: "Radio",
            template: {
              id: 0,
              order: 0,
              type: "Radio",
              properties: { 
                name: {value: "Radio",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                type: {value: "Boolean" ,  control:"ListBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                text: {value: "Radio",  control:"TextBox", hide:true},
                index: {value: false ,  control:"CheckBox"}
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                display: {value:"flex", hide:true},
                width: {value:"100px", hide:true},
                alignItems: {value:"center", hide:true},
                height: {value:"25px", hide:true},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 19,
            name: "RichTextBox",
            template: {
              id: 0,
              order: 0,
              type: "RichTextBox",
              properties: { 
                name: {value: "RichTextBox",  control:"TextBox"},
                field: {value: "RichTextBox" ,  control:"TextBox"},
                actions: {value: "",  control:"TextBox"}, 
                type: {value: "String" ,  control:"ListBox", hide:true},
                nullable: {value: true ,  control:"CheckBox"},
                size: {value: 100 ,  control:"TextBox"},
                text: {value: "RichTextBox",  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"}, 
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                  ]
                },
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                height: {value:"100px", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 20,
            name: "TextBox",
            template: {
              id: 0,
              order: 0,
              type: "TextBox",
              properties: { 
                name: {value: "TextBox",  control:"TextBox"}, 
                field: {value: "TextBox" ,  control:"TextBox"},
                text: {value: "",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                readOnly: {value: false ,  control:"CheckBox"},
                placeholder: {value: "" ,  control:"TextBox"},
                toolTip: {value: true ,  control:"CheckBox"}, 
                toolTipText: {value: "" ,  control:"TextBox"},
                maxLength: {value: 200 ,  control:"TextBox"},
                type: {value: "String",  
                  control:"ListBox",
                  values:[
                    {id: "0",  item:"String",  value:"String"},
                    {id: "1",  item:"Integer",  value:"Integer"},
                    {id: "2",  item:"Decimal",  value:"Decimal"},
                  ]
                },
                masks: {value: "" ,  control:"TextBox", maskValue:""},
                validations: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                    {id: "2",  item:"NUMBER",  value:{id:"2",  type:"NUMBER",events:["onChange", "onkeyPress"]}},
                    {id: "3",  item:"EMAIL",  value:{id:"3",  type:"EMAIL",events:["onBlur"]}},
                    {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}},
                    {id: "5",  item:"NOSPACE",  value:{id:"5",  type:"NOSPACE",events:["onkeyPress"]}},
                    {id: "6",  item:"NOSPECIALCHAR",  value:{id:"6",  type:"NOSPECIALCHAR",events:["onkeyPress"]}},
                    {id: "7",  item:"PATTERN",  value:{id:"7",  type:"PATTERN",events:["onBlur"]}}
                  ]
                },
                operators: {
                  value: "",  
                  control:"ListBoxCheckBox",
                  selectedValues:[],
                  values:[
                    {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                    {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                    {id: "3",  item:"greater",  value:{id:"3",  type:"greater"}},
                    {id: "4",  item:"greater & equal",  value:{id:"4",  type:"greater & equal"}},
                    {id: "5",  item:"lower",  value:{id:"5",  type:"lower"}},
                    {id: "6",  item:"lower & equal",  value:{id:"6",  type:"lower & equal"}},
                    {id: "7",  item:"contains",  value:{id:"7",  type:"contains"}},
                    {id: "8",  item:"starts with",  value:{id:"8",  type:"starts with"}},
                    {id: "9",  item:"ends with",  value:{id:"9",  type:"ends with"}}
                  ]
                },
                prefix: {value: "" ,  control:"TextBox"},
                suffix: {value: "" ,  control:"TextBox"},
                wholeNumberLength: {value: 10 ,  control:"TextBox"},
                decimalSize: {value: 2 ,  control:"TextBox"},
                decimalSeparator: {value: "" ,  control:"TextBox"},
                groupSize: {value: 3 ,  control:"TextBox"},
                groupSeparator: {value: "" ,  control:"TextBox"},
                index: {value: false ,  control:"CheckBox"}, 
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                fontSize: {value:"14px"},
                fontFamily: {value:"Arial"},
                color: {value:"#212121"},
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"100px", hide:true},
                display: {value:"flex", hide:true},
                height: {value:"25px", hide:true},
                visibility: {value:"visible"},
                borderLeft: {value:"1px solid #cccccc"},
                borderTop: {value:"1px solid #cccccc"},
                borderTopLeftRadius: {value:"2px"},
                borderTopRightRadius: {value:"2px"},
                borderRight: {value:"1px solid #cccccc"},
                borderBottom: {value:"1px solid #cccccc"},
                borderBottomLeftRadius: {value:"2px"},
                borderBottomRightRadius: {value:"2px"},
                background: {value:"white"},
                boxSizing: {value:"border-box", hide:true},
                textAlign: {value:"left"},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          },
          {
            id: 23,
            name: "TreeView",
            template: {
              id: 0,
              order: 0,
              type: "TreeBox",
              properties: {
                name: {value: "TreeBox",  control:"TextBox"},
                text: {value: "TreeBox",  control:"TextBox"},
                actions: {value: "",  control:"TextBox"},
                checkBox: {value: true,  type:"Boolean",  control:"CheckBox"},
                data: {value:{list:{}, mapping:{}, tree:{}}, options:["Tree"], control:"TextBox"}
              },
              policy: { read: true, edit: true, delete: true },
              styles: {
                
                left: {value:10, hide:true},
                top: {value:50, hide:true},
                width: {value:"150px", hide:true},
                height: {value:"25px", hide:true},
                display: {value:"flex", hide:true},
                boxSizing: {value:"border-box", hide:true},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
              },
            },
          }
        ],
      },
    ],
    data: {},
    sideDrawerOpen: false,
    
  });

  const drawerToggleClickHandler = () => {
    setState({...state, sideDrawerOpen: !state.sideDrawerOpen});
  };

  const backdropClickHandler = () => {
    setState({...state, sideDrawerOpen: false});
  };

   /* 
  useEffect(() => {
    const value = Cookies.get("ubini_flow_login")
    
    if (value != "" && !globalState.state.authentification)
      dispatch({
        type: "SET_AUTHENTIFICATION",
        payload: true
      });
        
  }, []); 
  
 */
  return (
   

    /*
     let backdrop;
    if (state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backdropClickHandler} />;
    }
       <div style ={{   paddingTop: "20px", background: "white"}}>
            <SideBar height = "100%" width = "80px"  />
          </div>
          {backdrop}
    */
    
        <Router> 
          <div>
            <Toolbar drawerClickHandler={drawerToggleClickHandler} height = "30px" />
            <SideDrawer show={state.sideDrawerOpen} />
            
            <main className="main">
            
              <Switch>
                <Route exact path="/">
                  <Accueil />  
                </Route>
                <Route exact path="/profilUser">
                  <User />
                </Route>
                <Route exact path="/demo">
                  <Demo />
                </Route>
                <Route exact path="/request">
                  <List />
                </Route>
                <Route exact path="/kanban">
                  <Kanban />
                </Route>
                <Route exact path="/Gantt">
                  <Gantt />
                </Route>
                <Route exact path="/home">
                  <Accueil />
                </Route> 
                <Route exact path="/signin">
                  <Authentification />
                </Route> 
                <Route exact path="/register">
                  <CreateAnAccount />
                </Route> 
                <Route exact path="/forgetPassword">
                  <ResetPassword />
                </Route> 
                <Route exact path="/changePassword">
                  <ChangePassword />
                </Route> 
                <Route exact path="/customHome">
               
                    <FormSettings isExecutionMode = {true} />
                  
                </Route> 
                <ProtectedRoute path="/information" component={Information} />
                <ProtectedRoute path="/StepSettings" component={SettingsStep} />
                 
                  

                
              </Switch>    
          
            </main>
          </div>
        </Router>
     
    );
  }
/*
 <RichTextEditor 
                data={{ id: "10"}}
                style ={{ height: "200px"}}              /> 



                <div  style ={{ marginLeft: "60px",  display: "flex", borderBottom: "1px solid  rgba(223, 221, 221)", minHeight:"650px"}}>
         
          <div >
             <FormSettings 
                formData={state.formData}
                tools={state.tools}
              /> 
                      
          </div>
          export default App;
  */

